(() => {
  function initializeProjects(container = document) {
    container.querySelectorAll('[data-project-proof]').forEach((root) => {
      if (root.dataset.projectsReady === 'true') return;
      root.dataset.projectsReady = 'true';
      const dialog = root.querySelector('.z30-project-viewer');
      const fullImage = root.querySelector('[data-project-full]');
      const loading = root.querySelector('[data-project-loading]');
      const heading = dialog?.querySelector('h2');
      const original = root.querySelector('[data-project-original]');
      const featured = root.querySelector('.z30-project-proof__featured');
      let returnFocus = null;

      function closeViewer() {
        if (dialog?.open) dialog.close();
      }

      root.addEventListener('click', (event) => {
        const scrollControl = event.target.closest('[data-project-scroll]');
        if (scrollControl && featured) {
          const card = featured.querySelector('.z30-project-card');
          const distance = (card?.getBoundingClientRect().width || featured.clientWidth) + 12;
          featured.scrollBy({
            left: distance * Number(scrollControl.dataset.projectScroll),
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
          return;
        }

        const link = event.target.closest('[data-project-image]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        returnFocus = link;
        heading.textContent = link.dataset.projectTitle || 'Projektaufnahme';
        original.href = link.href;
        fullImage.hidden = true;
        fullImage.alt = link.dataset.projectAlt || '';
        loading.hidden = false;
        loading.textContent = 'Aufnahme wird geladen …';
        fullImage.onload = () => {
          fullImage.hidden = false;
          loading.hidden = true;
        };
        fullImage.onerror = () => {
          loading.textContent = 'Die Aufnahme konnte nicht geladen werden. Bitte öffnen Sie die Originalaufnahme.';
        };
        fullImage.src = link.dataset.projectImage;
        dialog.showModal();
        document.documentElement.classList.add('z30-project-viewer-open');
      });

      root.querySelector('[data-project-close]')?.addEventListener('click', closeViewer);
      dialog?.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeViewer();
      });
      dialog?.addEventListener('close', () => {
        document.documentElement.classList.remove('z30-project-viewer-open');
        fullImage.hidden = true;
        fullImage.removeAttribute('src');
        returnFocus?.focus({ preventScroll: true });
      });
    });
  }

  initializeProjects();
  document.addEventListener('shopify:section:load', (event) => initializeProjects(event.target));
})();
